import { getDateStats, getStaticStats } from '@/api/requests';
import router from '../../router';

const state = {
  activeNow: 0,
  totalUsers: 0,
  totalProUsers: 0,
  totalWorkouts: 0,
  recentProRatio: 0,
  sessions: 0,
  uniqueSessions: 0,
  newUsers: 0,
  currentWorkouts: 0,
};

const mutations = {
  setActiveNow(state, payload) {
    state.activeNow = payload;
  },

  setTotalUsers(state, payload) {
    state.totalUsers = payload;
  },

  setTotalProUsers(state, payload) {
    state.totalProUsers = payload;
  },

  setCurrentWorkouts(state, payload) {
    state.currentWorkouts = payload;
  },

  setTotalWorkouts(state, payload) {
    state.totalWorkouts = payload;
  },

  setRecentProRatio(state, payload) {
    const prettyText = parseFloat(payload).toFixed(2);
    state.recentProRatio = prettyText;
  },

  setSessionStats(state, payload) {
    state.sessions = payload['session_count'];
    state.uniqueSessions = payload['unique_session_count'];
  },

  setNewUsers(state, payload) {
    state.newUsers = payload;
  }
};

const actions = {
  loadDateFilterStats(context, date) {
    getDateStats(date).then((response) => {
      const data = response.data;
      context.commit('setSessionStats', data.sessions);
      context.commit('setNewUsers', data.new_users);
      context.commit('setCurrentWorkouts', data.total_workouts);
    });
  },

  loadStaticStats(context) {
    getStaticStats().then((response) => {
      const data = response.data;
      context.commit('setActiveNow', data.active_now);
      context.commit('setTotalUsers', data.total_users);
      context.commit('setTotalWorkouts', data.total_workouts);
      context.commit('setTotalProUsers', data.total_pro_users);
      context.commit('setRecentProRatio', data.recent_pro_usage);
    });
  },
};

const getters = {

};

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};